module.exports = __webpack_public_path__ + "fonts/lato-bolditalic-webfont.4b21e414.woff";